(function(){
  var SIZES = [
    {au:'F',   us:'3',    circ:44.2, dia:14.1, eu:44},
    {au:'G',   us:'3\u00bd',   circ:45.5, dia:14.5, eu:45.5},
    {au:'H',   us:'4',    circ:46.8, dia:14.9, eu:47},
    {au:'I',   us:'4\u00bd',   circ:48.0, dia:15.3, eu:48},
    {au:'J',   us:'4\u00be',   circ:48.7, dia:15.5, eu:48.5},
    {au:'J\u00bd',  us:'5',    circ:49.3, dia:15.7, eu:49},
    {au:'K',   us:'5\u00bc',   circ:49.9, dia:15.9, eu:50},
    {au:'K\u00bd',  us:'5\u00bd',   circ:50.6, dia:16.1, eu:51},
    {au:'L',   us:'5\u00be',   circ:51.2, dia:16.3, eu:51},
    {au:'L\u00bd',  us:'6',    circ:51.9, dia:16.5, eu:52},
    {au:'M',   us:'6\u00bc',   circ:52.5, dia:16.7, eu:52.5},
    {au:'M\u00bd',  us:'6\u00bd',   circ:53.1, dia:16.9, eu:53},
    {au:'N',   us:'6\u00be',   circ:53.8, dia:17.1, eu:54},
    {au:'N\u00bd',  us:'7',    circ:54.4, dia:17.3, eu:54},
    {au:'O',   us:'7\u00bc',   circ:55.1, dia:17.5, eu:55},
    {au:'O\u00bd',  us:'7\u00bd',   circ:55.7, dia:17.7, eu:56},
    {au:'P',   us:'7\u00be',   circ:56.3, dia:17.9, eu:56.5},
    {au:'P\u00bd',  us:'8',    circ:57.0, dia:18.1, eu:57},
    {au:'Q',   us:'8\u00bc',   circ:57.6, dia:18.3, eu:57.5},
    {au:'Q\u00bd',  us:'8\u00bd',   circ:58.3, dia:18.5, eu:58},
    {au:'R',   us:'8\u00be',   circ:58.9, dia:18.7, eu:59},
    {au:'R\u00bd',  us:'9',    circ:59.5, dia:19.0, eu:59},
    {au:'S',   us:'9\u00bc',   circ:60.2, dia:19.2, eu:60},
    {au:'S\u00bd',  us:'9\u00bd',   circ:60.8, dia:19.4, eu:61},
    {au:'T',   us:'9\u00be',   circ:61.4, dia:19.6, eu:61.5},
    {au:'T\u00bd',  us:'10',   circ:62.1, dia:19.8, eu:62},
    {au:'U',   us:'10\u00bc',  circ:62.7, dia:20.0, eu:62.5},
    {au:'U\u00bd',  us:'10\u00bd',  circ:63.4, dia:20.2, eu:63},
    {au:'V',   us:'10\u00be',  circ:64.0, dia:20.4, eu:64},
    {au:'V\u00bd',  us:'11',   circ:64.6, dia:20.6, eu:65},
    {au:'W',   us:'11\u00bc',  circ:65.3, dia:20.8, eu:65.5},
    {au:'W\u00bd',  us:'11\u00bd',  circ:65.9, dia:21.0, eu:66},
    {au:'X',   us:'11\u00be',  circ:66.5, dia:21.2, eu:66.5},
    {au:'X\u00bd',  us:'12',   circ:67.2, dia:21.4, eu:67},
    {au:'Y',   us:'12\u00bc',  circ:67.8, dia:21.6, eu:68},
    {au:'Y\u00bd',  us:'12\u00bd',  circ:68.5, dia:21.8, eu:68.5},
    {au:'Z',   us:'12\u00be',  circ:69.1, dia:22.0, eu:69},
    {au:'Z\u00bd',  us:'13',   circ:69.7, dia:22.2, eu:70}
  ];

  function init(){
    var root = document.querySelector('.cj-rsg');
    if(!root) return;

    // Tabs
    var tabs = root.querySelectorAll('.cj-rsg-tab');
    var panels = root.querySelectorAll('.cj-rsg-panel');
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        tabs.forEach(function(t){ t.classList.remove('cj-selected'); });
        panels.forEach(function(p){ p.classList.remove('cj-active'); });
        tab.classList.add('cj-selected');
        root.querySelector('.cj-rsg-panel[data-panel="' + tab.dataset.tab + '"]').classList.add('cj-active');
      });
    });

    function nearestByMm(value, key){
      var best = SIZES[0], bestDiff = Math.abs(SIZES[0][key] - value);
      SIZES.forEach(function(s){
        var diff = Math.abs(s[key] - value);
        if(diff < bestDiff){ best = s; bestDiff = diff; }
      });
      return best;
    }
    function labelFor(sys, s){
      if(sys === 'au') return s.au;
      if(sys === 'us') return s.us;
      if(sys === 'eu') return s.eu;
      if(sys === 'dia') return s.dia.toFixed(1) + 'mm';
      if(sys === 'circ') return s.circ.toFixed(1) + 'mm';
    }

    // Convert tab
    var fromSystem = root.querySelector('#cjFromSystem');
    var toSystem = root.querySelector('#cjToSystem');
    var fromField = root.querySelector('#cjFromField');
    var fromIndex = null, fromMm = null;

    function renderFromField(){
      var sys = fromSystem.value;
      fromIndex = null; fromMm = null;
      if(sys === 'dia' || sys === 'circ'){
        fromField.innerHTML = '<input type="number" id="cjFromMm" class="cj-rsg-select" step="0.1" placeholder="e.g. 54.4">';
        root.querySelector('#cjFromMm').addEventListener('input', function(e){
          fromMm = parseFloat(e.target.value);
          updateResult();
        });
      } else {
        fromField.innerHTML = '<div class="cj-rsg-option-grid" id="cjFromGrid"></div>';
        var grid = root.querySelector('#cjFromGrid');
        SIZES.forEach(function(s, i){
          var chip = document.createElement('div');
          chip.className = 'cj-rsg-option-chip';
          chip.textContent = labelFor(sys, s);
          chip.addEventListener('click', function(){
            grid.querySelectorAll('.cj-rsg-option-chip').forEach(function(c){ c.classList.remove('cj-selected'); });
            chip.classList.add('cj-selected');
            fromIndex = i;
            updateResult();
          });
          grid.appendChild(chip);
        });
      }
      updateResult();
    }
    function updateResult(){
      var sys = fromSystem.value;
      var s = null;
      if(sys === 'dia' || sys === 'circ'){
        if(fromMm !== null && !isNaN(fromMm)) s = nearestByMm(fromMm, sys);
      } else if(fromIndex !== null){
        s = SIZES[fromIndex];
      }
      root.querySelector('#cjResultValue').textContent = s ? labelFor(toSystem.value, s) : '\u2014';
    }
    fromSystem.addEventListener('change', renderFromField);
    toSystem.addEventListener('change', updateResult);
    renderFromField();

    // Measure tab
    function showMeasureResult(s, note){
      root.querySelector('#cjMeasureResult').classList.add('cj-show');
      root.querySelector('#cjM-au').textContent = s.au;
      root.querySelector('#cjM-us').textContent = s.us;
      root.querySelector('#cjM-eu').textContent = s.eu;
      root.querySelector('#cjM-dia').textContent = s.dia.toFixed(1) + 'mm';
      root.querySelector('#cjM-circ').textContent = s.circ.toFixed(1) + 'mm';
      root.querySelector('#cjMeasureNote').textContent = note;
    }
    root.querySelector('#cjCircBtn').addEventListener('click', function(){
      var v = parseFloat(root.querySelector('#cjCircInput').value);
      if(isNaN(v)) return;
      showMeasureResult(nearestByMm(v, 'circ'), 'Closest match to a ' + v.toFixed(1) + 'mm circumference. If your reading falls between two rows, we recommend sizing up.');
    });
    root.querySelector('#cjDiaBtn').addEventListener('click', function(){
      var v = parseFloat(root.querySelector('#cjDiaInput').value);
      if(isNaN(v)) return;
      showMeasureResult(nearestByMm(v, 'dia'), 'Closest match to a ' + v.toFixed(1) + 'mm diameter. If your reading falls between two rows, we recommend sizing up.');
    });

    // Full table
    var tbody = root.querySelector('#cjFullTable');
    var mobileList = root.querySelector('#cjMobileList');
    SIZES.forEach(function(s){
      var tr = document.createElement('tr');
      tr.innerHTML = '<td>' + s.au + '</td><td>' + s.us + '</td><td>' + s.eu + '</td><td>' + s.dia.toFixed(1) + '</td><td>' + s.circ.toFixed(1) + '</td>';
      tbody.appendChild(tr);

      var row = document.createElement('div');
      row.className = 'cj-rsg-mobile-row';
      row.innerHTML =
        '<div class="cj-rsg-mrow-au">AU/UK ' + s.au + '</div>' +
        '<div><span class="cj-rsg-mrow-k">US/CA </span>' + s.us + '</div>' +
        '<div><span class="cj-rsg-mrow-k">EU </span>' + s.eu + '</div>' +
        '<div><span class="cj-rsg-mrow-k">Diameter </span>' + s.dia.toFixed(1) + 'mm</div>' +
        '<div><span class="cj-rsg-mrow-k">Circumference </span>' + s.circ.toFixed(1) + 'mm</div>';
      mobileList.appendChild(row);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
